import { caseFold } from "unicode-case-folding";

import { normalizeSkillEditorText } from "./skill-editor-state";

const slugifyFilenameStem = (value: string): string =>
    value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9_\t\n\v\f\r -]/g, "")
        .replace(/[\t\n\v\f\r _]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");

export const getSkillEditorPublishedFilenameStem = (name: string): string => {
    const lastDot = name.lastIndexOf(".");
    return slugifyFilenameStem(lastDot <= 0 ? name : name.slice(0, lastDot));
};

export function getSkillEditorPublishedFilename(name: string): string {
    const lastDot = name.lastIndexOf(".");
    if (lastDot <= 0) {
        return `${slugifyFilenameStem(name)}.md`;
    }
    return `${slugifyFilenameStem(name.slice(0, lastDot))}.${name.slice(lastDot + 1)}`;
}

export const getSkillEditorPublishedFilenameComparisonKey = (name: string) =>
    caseFold(
        getSkillEditorPublishedFilename(normalizeSkillEditorText(name)).trim()
    );

export const skillEditorFileNamesCollide = (
    leftName: string,
    rightName: string
) => {
    const left = normalizeSkillEditorText(leftName);
    const right = normalizeSkillEditorText(rightName);
    return (
        left.toLowerCase() === right.toLowerCase() ||
        getSkillEditorPublishedFilenameComparisonKey(left) ===
            getSkillEditorPublishedFilenameComparisonKey(right)
    );
};
